import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'
import type { UnitPreference } from '../lib/units'

export function useUnitPreference(campaignId: string | undefined) {
  const queryClient = useQueryClient()

  const query = useQuery({
    queryKey: ['unit-preference', campaignId],
    enabled: !!campaignId,
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser()
      if (!user) throw new Error('Not authenticated')

      const { data, error } = await supabase
        .from('campaign_members')
        .select('unit_preference')
        .eq('campaign_id', campaignId!)
        .eq('user_id', user.id)
        .single()

      if (error) throw error
      return (data?.unit_preference ?? 'imperial') as UnitPreference
    },
  })

  const mutation = useMutation({
    mutationFn: async (pref: UnitPreference) => {
      const { data: { user } } = await supabase.auth.getUser()
      if (!user) throw new Error('Not authenticated')

      const { error } = await supabase
        .from('campaign_members')
        .update({ unit_preference: pref })
        .eq('campaign_id', campaignId!)
        .eq('user_id', user.id)

      if (error) throw error
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['unit-preference', campaignId] })
    },
  })

  return {
    pref: query.data ?? 'imperial' as UnitPreference,
    setPref: mutation.mutateAsync,
    isLoading: query.isLoading,
  }
}
